import { z } from 'zod'
import { promotionSchema } from '@/modules/sales/clients/types/Promotion.ts'

export const equalityDeviceInfoSchema = z.object({
  modelId: z.string(),
  modelName: z.string(),
  maxCost: z.string().nullable(),
  stateInfo: z.enum(['active']),
  promotion: promotionSchema.nullable()
})
